module.exports = __webpack_public_path__ + "img/50.95454c18.jpg";